import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

import BgBar from './BgBar';
import MobilePopup from './MobilePopup';
import AmbAudio from './AmbAudio';
import BgAudio from './BgmComponents';
import TimeWeather from './TimeWeather';
import PomodoroTimer from './PomodoroTimer';
import Footer from './Footer';
import AddTask from './AddTask'

import { getAuth } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import { signOut } from 'firebase/auth';
import 'firebase/compat/firestore';
import { firebaseConfig, db } from './firebase';

import './App.css';

firebase.initializeApp(firebaseConfig);

const HomePage = ({selectedColors}) => {
    const { leftBarColor = '#1e1e1e' } = selectedColors || {};

    const auth = getAuth();
    
    const [firebaseUserInfo, setFirebaseUserInfo] = useState(null);
    const displayName = (firebaseUserInfo && firebaseUserInfo.displayName) || "Guest";
    
   
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setFirebaseUserInfo(user);
        });
        
        return () => unsubscribe();
    }, [auth]);

    //Handles the signout 
    const handleSignOut = (event) => {
    signOut(getAuth());
    console.log(auth)
    }

    return (
    
        <div className="page-container">
            <div className="content-wrap">
                <main>
                    <MobilePopup />
        
            <section>                   
                     <div className='left-bar' style={{ backgroundColor: selectedColors.leftBarColor }}>

                        <div className="user-container">
                            <div className="user-item">
                                <img id="user" src="img/profile.png" alt="User profile picture" />
                            </div>
                            <div className="user-item">
                                <div className="hello-container">
                                    <div className="hello-item">
                                        <p className="hello"> Hello, {displayName} </p>
                                    </div>
                                    <div className="hello-item">
                                        <Link to="/welcome">
                                            <button className="logout" onClick={handleSignOut}>Sign Out</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <AmbAudio />
                        <BgAudio />
                        <BgBar />
                    </div>
            </section>

        <section>
            <div className="right-container">
            <div className="weather-bar" style={{ backgroundColor: selectedColors.leftBarColor }}>
            <TimeWeather />
            </div>
                <div className="right-time-bar" style={{ backgroundColor: selectedColors.leftBarColor }}>
                    <div className="timer">
                        <PomodoroTimer />
                    </div>
                </div>
            <div className="task-bar" style={{ backgroundColor: selectedColors.leftBarColor }}>
                <h2>Tasks List</h2>
                <AddTask />
            </div>
        </div>
        
        </section>
        </main>
        </div>
            <Footer />
    </div>
    )
};

export default HomePage;